"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LookupService = void 0;
var rxjs_1 = require("rxjs");
var core_1 = require("@athena-portal/core");
function L(id, value) {
    return {
        id: id,
        value: value
    };
}
var LookupService = exports.LookupService = /** @class */ (function () {
    function LookupService() {
        this.lookups = {
            title: [
                L("1", "Mr"),
                L("2", "Ms"),
                L("3", "Mrs"),
                L("4", "Miss"),
            ],
            occupationStatus: [
                L("1", "Occupied"),
                L("2", "Self-occupied"),
                L("3", "Retired"),
                L("4", "Other"),
            ],
            occupation: [
                L("1", "Developer"),
                L("2", "Tester"),
                L("3", "Business Analyst"),
                L("4", "Project manager"),
            ],
            occupationType: [
                L("1", "Insurance"),
                L("2", "Banking"),
                L("3", "IT"),
            ]
        };
    }
    LookupService.prototype.fetchLookupValues = function (lookupName, languageCode) {
        var lookups = this.lookups[lookupName] || [];
        return (0, rxjs_1.of)(lookups);
    };
    LookupService = __decorate([
        (0, core_1.injectable)()
    ], LookupService);
    return LookupService;
}());
//# sourceMappingURL=LookupService.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/plugin-journey/dist/services/impl/LookupService.js
// module id = 2291
// module chunks = 0